import { isNil } from 'lodash/fp';
import { DateTime } from 'luxon';
import { useSelector } from 'app/lib/hooks';
import { selectQueryForPropQueryId } from 'app/store/snowflakeQueries';
import { TimeLapsed } from 'app/components/core/TimeLapsed';

export function Duration({ queryId }) {
    const query = useSelector(selectQueryForPropQueryId, { queryId });
    const { startedAt, finishedAt } = query;

    if (isNil(finishedAt)) {
        return <TimeLapsed startTime={startedAt} />;
    }

    const startTime = DateTime.fromISO(startedAt, { zone: 'utc' });
    const endTime = DateTime.fromISO(finishedAt, { zone: 'utc' });
    const duration = endTime.diff(startTime).toFormat("m'min' s's'");

    return <time>{duration}</time>;
}
